import React from "react";
import { Button, Modal, Typography, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DeleteModal = ({ open, onClose, onConfirm, cFileName }) => {
  const modalStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const paperStyle = {
    backgroundColor: "#ffffff",
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.064)",
    padding: "20px",
    textAlign: "center",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "relative", // for positioning the close button
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
      style={modalStyle}
    >
      <Box sx={{ ...paperStyle, width: "370px", height: "250px" }}>
        {/* Close Icon */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#555",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography
          variant="h6"
          sx={{ fontSize: "1.1em", lineHeight: "2" }} // added lineHeight
          gutterBottom
        >
          Are you sure you want to permanently delete {cFileName}?
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Button variant="contained" color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            sx={{ ml: 2 }}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
